/* eslint-disable */
/* oxlint-disable */
/* prettier-ignore-file */
// @ts-nocheck
// This file is auto-generated. Do not edit manually.
// Run 'pnpm codegen' to regenerate this file.

export type AccountId = string;
export type AccountIdJsonValue = string;
export function AccountId_fromJsonValue(json: AccountIdJsonValue): AccountId {
  return json;
}
export function AccountId_toJsonValue(value: AccountId): AccountIdJsonValue {
  return value;
}

export type Currency = string;
export type CurrencyJsonValue = string;
export function Currency_fromJsonValue(json: CurrencyJsonValue): Currency {
  return json;
}
export function Currency_toJsonValue(value: Currency): CurrencyJsonValue {
  return value;
}

export type IntervalKey = string;
export type IntervalKeyJsonValue = string;
export function IntervalKey_fromJsonValue(json: IntervalKeyJsonValue): IntervalKey {
  return json;
}
export function IntervalKey_toJsonValue(value: IntervalKey): IntervalKeyJsonValue {
  return value;
}

export type PositionKey = string;
export type PositionKeyJsonValue = string;
export function PositionKey_fromJsonValue(json: PositionKeyJsonValue): PositionKey {
  return json;
}
export function PositionKey_toJsonValue(value: PositionKey): PositionKeyJsonValue {
  return value;
}

export type Symbol = string;
export type SymbolJsonValue = string;
export function Symbol_fromJsonValue(json: SymbolJsonValue): Symbol {
  return json;
}
export function Symbol_toJsonValue(value: Symbol): SymbolJsonValue {
  return value;
}

export type AccountPositionKey = string;
export type AccountPositionKeyJsonValue = string;
export function AccountPositionKey_fromJsonValue(json: AccountPositionKeyJsonValue): AccountPositionKey {
  return json;
}
export function AccountPositionKey_toJsonValue(value: AccountPositionKey): AccountPositionKeyJsonValue {
  return value;
}

export type AccountOrderKey = string;
export type AccountOrderKeyJsonValue = string;
export function AccountOrderKey_fromJsonValue(json: AccountOrderKeyJsonValue): AccountOrderKey {
  return json;
}
export function AccountOrderKey_toJsonValue(value: AccountOrderKey): AccountOrderKeyJsonValue {
  return value;
}

export type Uuid = string;
export type UuidJsonValue = string;
export function Uuid_fromJsonValue(json: UuidJsonValue): Uuid {
  return json;
}
export function Uuid_toJsonValue(value: Uuid): UuidJsonValue {
  return value;
}
